import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class personalinformation {
  StudentID:number; 
  StudentName:string;  
  PreStudentOtherCourseID:number;
  AcademicInstanceID:number;
  PRNNO:string; 
  StudentSexCode:string;
  StudentBirthDate:string;
  Gender:string;
  BirthYear:string;
  StudentCourseID:number;
  OthCourseName : string;
  OthCourseAuthority : string;
  OthCourseYear : string;
  OthCourseGrade : string;
  OthCourseCert: string;
  CreatedLoginID:number;
  UpdatedLoginID:number; 
}
@Injectable({
  providedIn: 'root'
})
export class OtherCoursesInfoService {
  constructor(private dataService: DataAccessService) { }
  public OtherCoursesInfoServiceData: OtherCoursesInfoService;

  
  public GetPersonalInformation(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByID?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<personalinformation[]>()
  } 
  
  public GetPreStudentInformationForCertificateInfo(CollegeID, CoursePartID, BranchID, CourseID, AcademicInstanceID, PreStudentOtherCourseID, StudentID) {
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'GetPreStudentInformationForCertificateInfo?CollegeID='+ CollegeID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&CourseID='+CourseID+'&AcademicInstanceID='+AcademicInstanceID+'&PreStudentOtherCourseID='+PreStudentOtherCourseID+'&StudentID='+StudentID ; 
    return this.dataService.getAll<personalinformation[]>()
  } 
  
  public GetPreStudentInformationForCertificateInfoList(CollegeID, CoursePartID, BranchID, CourseID, AcademicInstanceID, PreStudentOtherCourseID, StudentID) {
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'GetPreStudentInformationForCertificateInfoList?CollegeID='+ CollegeID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&CourseID='+CourseID+'&AcademicInstanceID='+AcademicInstanceID+'&PreStudentOtherCourseID='+PreStudentOtherCourseID+'&StudentID='+StudentID ; 
    return this.dataService.getAll<personalinformation[]>()
  } 
  
  
  public PostInsertCertificateInfo(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostInsertCertificateInfo'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
  public PostCertificateInfo(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostCertificateInfo'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
  
  public PostRemovedExtraCertificate(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostRemovedExtraCertificate'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
  public PostDeleteCertificateInfo(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostDeleteCertificateInfo'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
}
